import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { BUILD_INFO } from './buildInfo'
import { initSentry } from './lib/sentry'

// Initialize Sentry before rendering
initSentry();

// Log build info and check for React
console.log('🚀 [Main] Starting app...', BUILD_INFO);
console.log('⚛️ [Main] React version:', React.version);

// Unregister any service workers to prevent caching issues
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    if (registrations.length > 0) {
      console.warn('⚠️ [Main] Service workers detected - unregistering...');
      registrations.forEach(registration => {
        registration.unregister().then(() => {
          console.log('✅ [Main] Service worker unregistered');
        });
      });
    }
  });
}

// Add global error handler for React errors
window.addEventListener('error', (event) => {
  console.error('🔴 [Global Error]', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  });
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
